export default __webpack_public_path__ + "static/media/98_mobile.50845a8e.jpg";